module.exports = __webpack_public_path__ + "images/landing/light/card-maker.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/light/card-maker.png
// module id = h+vD
// module chunks = 51